
import { Component, Vue } from "vue-property-decorator";
import { SMUser } from "@/store";
import NotificationTemplate from "@/components/NotificationTemplate/NotificationTemplate.vue";
import { NOTIFICATION_PROPS } from "@/constants/notification";

@Component({
  components: {
    NotificationTemplate,
  },
})
export default class NotificationCosPlusSwStarted extends Vue {
  notificationProps = NOTIFICATION_PROPS;

  get isEmployer() {
    return SMUser.isEmployer;
  }

  get text() {
    if (this.isEmployer) return this.$t("text.employer");

    return this.$t("text.candidate");
  }
}
